import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ProgressBar } from 'devextreme-react/progress-bar';

const maxValue = 60;
let intervalId: any;

const statusFormat = (ratio: any) => {
  return `Tiến độ xử lý: ${Math.floor(ratio * 100)}%`;
};

export const LoadingModal = (props: any) => {
    const {isOpen, text} = props;
    
    const [seconds, setSeconds] = useState(maxValue);

    const progressColor = (value: any) => {
        if (value <= 3) {
          return '#f44336'; // Red color
        }
        if (value <= 6) {
          return '#ff9800'; // Orange color
        }
        return '#4caf50'; // Green color
      };

    
    useEffect(() => {
        if (isOpen){
            intervalId = setInterval(() => {
              setSeconds(prevSeconds => prevSeconds - 1);
            }, 1000);
        
            return () => {
              clearInterval(intervalId);
            };
        }
    }, [isOpen]);
    
    useEffect(() => {
        if (isOpen) {
            if (seconds === 0) {
              setSeconds(maxValue);
            }
        }
    }, [isOpen, seconds]);  

    return (
        <Modal
            show={isOpen}
            // onHide={false}
            centered
            size={'lg'}
            className="add-folder-modal"
            backdrop="static"
            contentClassName='loading-modal'
        >
                {/* <Spinner show={true} /> */}
            <h3 className="py-4" style={{textAlign: 'center'}}>{text}</h3>
            <div className="px-4">
                <ProgressBar
                    id="progress-bar-status"
                    className={seconds === 0 ? 'complete' : ''}
                    width="100%"
                    min={0}
                    max={maxValue}
                    statusFormat={statusFormat}
                    value={maxValue - seconds}
                    height={50}
                    elementAttr={{
                        style: { background: progressColor(maxValue - seconds) },
                    }}
                />
            </div>
            <Modal.Body className="py-4 px-8">
              {/* <div className='d-flex column'>
                <img src="/assets/images/loading-gif.gif" alt="no" />
              </div> */}
            </Modal.Body>
        </Modal>
    );
}